import { all, call, put, select, takeLatest } from 'redux-saga/effects'
import { t } from 'i18next'
import {
    CustomerNotificationActionTypes,
    CustomerNotificationActions,
} from '../constant/notification.const'
import CustomerNotificationService from '../../services/portal/customer-notification.service'
import {
    RelatedType,
    ToggleNotificationRequest,
    ToggleNotificationResponse,
} from '../../type/NotificationType'
import { ArtistActionTypes } from '../constant/artist.const'
import { GlobalLoadingTypes } from '../constant/global-loading.const'
import { rootState } from '..'
import { FavoriteType } from '../../type/FavoriteType'
import { GroupFavoriteType } from '../../type/GroupFavoriteType'
import { ArtistGroupActionType } from '../constant/group.const'

export function* toggleNotificationArtist(
    actions: CustomerNotificationActions
) {
    const data: ToggleNotificationRequest = {
        customerId: actions.payload.customer_id,
        relatedType: actions.payload.related_type,
        relatedId: actions.payload.related_id,
    }

    yield put({
        type: GlobalLoadingTypes.setGlobalLoading,
        payload: true,
    })

    try {
        const aritstFavorites: FavoriteType[] = yield select(
            (state: rootState) => state.artist.favorites
        )
        const aritstGroupFavorites: GroupFavoriteType[] = yield select(
            (state: rootState) => state.artistGroup.favorites
        )
        const response: ToggleNotificationResponse = yield call(
            CustomerNotificationService.toggleNotification.bind(
                CustomerNotificationService
            ),
            data
        )

        yield put({
            type: CustomerNotificationActionTypes.setSuccessDataExecuted,
            payload: {
                customerId: actions.payload.customer_id,
                relatedType: actions.payload.related_type,
                relatedId: actions.payload.related_id,
                isEnableNotification: response.is_enable_notification,
            },
        })

        switch (actions.payload.related_type) {
            case RelatedType.CATEGORY:
                // eslint-disable-next-line no-case-declarations
                const newArtistFavorites = aritstFavorites.map(
                    (artistFavorite) => {
                        return Number(artistFavorite.artistId) ===
                            Number(actions.payload.related_id)
                            ? {
                                  ...artistFavorite,
                                  isEnableNotification:
                                      response.is_enable_notification,
                              }
                            : artistFavorite
                    }
                )

                yield put({
                    type: ArtistActionTypes.setFavorites,
                    payload: newArtistFavorites,
                })

                break
            case RelatedType.ARTIST_GROUP:
                // eslint-disable-next-line no-case-declarations
                const newArtistGroupFavorites = aritstGroupFavorites.map(
                    (artistGroupFavorite) => {
                        return Number(artistGroupFavorite.groupId) ===
                            Number(actions.payload.related_id)
                            ? {
                                  ...artistGroupFavorite,
                                  isEnableNotification:
                                      response.is_enable_notification,
                              }
                            : artistGroupFavorite
                    }
                )

                yield put({
                    type: ArtistGroupActionType.setFavorites,
                    payload: newArtistGroupFavorites,
                })

                break
        }
    } catch (error) {
        alert(t('error.server_error'))
    } finally {
        yield put({
            type: GlobalLoadingTypes.setGlobalLoading,
            payload: false,
        })
    }
}

export function* customerNotificationSaga() {
    yield all([
        takeLatest(
            CustomerNotificationActionTypes.toggleNotification,
            toggleNotificationArtist
        ),
    ])
}
